import useAuthMiddleware from "../../middlewares/AuthMiddleware";
import useCompanyTypeMiddleware from "../../middlewares/CompanyTypeMiddleware";
import useMiddlewares from "../../middlewares/Middleware";
import usePermissionMiddleware from "../../middlewares/PermissionMiddleware";
import useRoleTypeMiddleware from "../../middlewares/RoleTypeMiddleware";
import useRouteValidator from "./RouteValidator";

/**
 * @returns {{ validate: () => boolean|{ to: string, replace: boolean }}}
 */
function useAttendanceListRouteValidator() {
  return useRouteValidator(
    useMiddlewares([
      useAuthMiddleware(),
      useCompanyTypeMiddleware(["default", "business_center"]),
      useRoleTypeMiddleware(["superadmin", "user"]),
      usePermissionMiddleware(["attendance_list.read", "attendance_list.read.screen"]),
    ])
  );
}

export default useAttendanceListRouteValidator;
